/**
 * Slider
 */
 class TJ_Slider {
  constructor(sliderSelector, isInstagram) {
    if(!sliderSelector.length) {
      return;
    }

    this.isInstagram = isInstagram;
    this.initSlider(sliderSelector, isInstagram);
    this.initEvents();
  }

  initSlider (sliderSelector) {
    let itemsPerPage = 2;
    this.UI = {};
    this.UI.wrapper = sliderSelector.find('.slider-wrapper');
    this.UI.slider = this.UI.wrapper.find('.slider-list');
    this.UI.btnsWrapper = sliderSelector.find('.slider-buttons');
    this.UI.btnPrev = this.UI.btnsWrapper.find('.slider-prev');
    this.UI.btnNext = this.UI.btnsWrapper.find('.slider-next');
    this.UI.items = this.UI.slider.find('.slider-list-item');

    if (this.isInstagram) {
      this.UI.wrapper = sliderSelector.find('#sb_instagram');
      this.UI.slider = this.UI.wrapper.find('#sbi_images');
      this.UI.items = this.UI.slider.find('.sbi_item');
      itemsPerPage = 4;
    }

    this.wrapperWidth = this.UI.wrapper.outerWidth();
    this.sliderWidth = this.UI.slider.outerWidth(true);

    this.setItemsPerPage(itemsPerPage);

    this.animationInProgress = false;
  }

  initEvents() {
    if (this.UI.wrapper.length) {
      this.initRWD();
      this.initUI();
    }
  }

  initUI () {
    this.swipeEffect = new Hammer(this.UI.wrapper[0]);
    this.swipeEffect.on('swipe', ev => {
      if (this.animationInProgress) {
        return;
      }

      if (ev.type === 'swipe' && ev.direction === 2) {
        this.showNextSlide();
      }
      if (ev.type === 'swipe' && ev.direction === 4) {
        this.showPreviousSlide();
      }
    });

    this.UI.btnPrev.on('click', e => {
      e.preventDefault();
      if (this.animationInProgress) {
        return;
      }

      this.showPreviousSlide();
    });

    this.UI.btnNext.on('click', e => {
      e.preventDefault();
      if (this.animationInProgress) {
        return;
      }

      this.showNextSlide();
    });
  }

  showNextSlide () {
    let currentSlide = this.getCurrentItem();
    currentSlide++;
    this.setCurrentItem(currentSlide);
  }

  showPreviousSlide () {
    let currentSlide = this.getCurrentItem();
    currentSlide--;
    this.setCurrentItem(currentSlide);
  }

  setCurrentItem (newValue) {
    if (this.animationInProgress) {
      return;
    }
    this.animationInProgress = true;

    this.UI.btnNext.addClass('is-inactive');
    this.UI.btnPrev.addClass('is-inactive');

    if (newValue > this.UI.items.length - (this.itemsPerPage - 1)) {
      newValue = 1;
    } else if (newValue < 1) {
      newValue = this.UI.items.length;
    }
    this.currentItem = newValue;

    let itemWidth = this.UI.items.eq(0).outerWidth(true);
    this.UI.wrapper.attr('data-current', (newValue).toString());

    let newMargin = (- itemWidth * (this.currentItem - 1));

    /*if ((this.sliderWidth + newMargin) < this.wrapperWidth) {
      newMargin = this.wrapperWidth - this.sliderWidth;
    }*/

    this.UI.slider.css('transform', 'translateX(' + newMargin + 'px)');

    setTimeout(() => {
      this.UI.btnNext.removeClass('is-inactive');
      this.UI.btnPrev.removeClass('is-inactive');

      this.animationInProgress = false;
      if (this.currentItem <= (this.UI.items.length - this.itemsPerPage)) {
        this.UI.btnNext.removeClass('is-disabled');  
      }

      if (this.currentItem !== 1) {
        this.UI.btnPrev.removeClass('is-disabled');
      }
    }, 550);
  }

  getCurrentItem () {
    return parseInt(this.UI.wrapper.attr('data-current'), 10);
  }

  initRWD () {
    let trippleSlidesViewport = window.matchMedia('(min-width: 1025px)');
    let doubleSlidesViewport = window.matchMedia('(min-width:721px) and (max-width: 1024px)');
    let singleSlidesViewport = window.matchMedia('(max-width: 720px)');
    if (singleSlidesViewport.matches) {
      this.itemsPerPage = 1;
    } else if (doubleSlidesViewport.matches) {
      this.itemsPerPage = 2;
    } else {
      this.itemsPerPage = 2;
    }

    this.setItemsPerPage(this.itemsPerPage);

    singleSlidesViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(1);
      }
    });
    doubleSlidesViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(2);
      }
    });
    trippleSlidesViewport.addListener(mq => {
      if (mq.matches) {
        this.setItemsPerPage(2);
      }
    });
  }

  setItemsPerPage (numberOfItems) {
    this.currentItem = 1;
    this.itemsPerPage = numberOfItems;
    this.UI.slider.css('margin-left', '0%');
    this.UI.wrapper.attr('data-current', '1');

    if (this.UI.items.length === this.itemsPerPage) {
      this.UI.btnsWrapper.addClass('is-hidden');
    } else {
      this.UI.btnsWrapper.removeClass('is-hidden');
    }

    this.UI.btnPrev.addClass('is-disabled');
  }
}
